import { Send } from "lucide-react";
import type { ComponentType, SVGProps } from "react";

import { CONTACT_EMAIL, SOCIAL_LINKS } from "@/lib/brand";

// Brand-mark paths are from Simple Icons; Lucide no longer includes trademarks.

export function XIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
    </svg>
  );
}

export function DiscordIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
      <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
    </svg>
  );
}

export function YouTubeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

export function TikTokIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
    </svg>
  );
}

export function MailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  );
}

// Strip the scheme so the /contact page can show a clean literal reference
// (e.g. "x.com/MavoriAI") next to the icon — the textual fallback for anyone
// whose click on the icon goes nowhere.
function displayUrl(url: string): string {
  return url.replace(/^https?:\/\//, "");
}

export type ContactChannel = {
  key: string;
  /** Channel name shown as the row heading and used for aria-labels. */
  label: string;
  /** Where the icon / primary link points. */
  href: string;
  /** Literal, copy-pasteable reference shown as visible text. */
  display: string;
  /** Value to copy when the copy affordance is used (email address / URL). */
  copyValue: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Open in a new tab (true for external socials, false for mail/internal). */
  external: boolean;
};

export const CONTACT_CHANNELS: readonly ContactChannel[] = [
  {
    key: "x",
    label: "X",
    href: SOCIAL_LINKS.x,
    display: displayUrl(SOCIAL_LINKS.x),
    copyValue: SOCIAL_LINKS.x,
    Icon: XIcon,
    external: true,
  },
  {
    key: "discord",
    label: "Discord",
    href: SOCIAL_LINKS.discord,
    display: displayUrl(SOCIAL_LINKS.discord),
    copyValue: SOCIAL_LINKS.discord,
    Icon: DiscordIcon,
    external: true,
  },
  {
    key: "telegram",
    label: "Telegram",
    href: SOCIAL_LINKS.telegram,
    display: displayUrl(SOCIAL_LINKS.telegram),
    copyValue: SOCIAL_LINKS.telegram,
    Icon: Send,
    external: true,
  },
  {
    key: "youtube",
    label: "YouTube",
    href: SOCIAL_LINKS.youtube,
    display: displayUrl(SOCIAL_LINKS.youtube),
    copyValue: SOCIAL_LINKS.youtube,
    Icon: YouTubeIcon,
    external: true,
  },
  {
    key: "tiktok",
    label: "TikTok",
    href: SOCIAL_LINKS.tiktok,
    display: displayUrl(SOCIAL_LINKS.tiktok),
    copyValue: SOCIAL_LINKS.tiktok,
    Icon: TikTokIcon,
    external: true,
  },
  {
    key: "email",
    label: "Email",
    href: `mailto:${CONTACT_EMAIL}`,
    display: CONTACT_EMAIL,
    copyValue: CONTACT_EMAIL,
    Icon: MailIcon,
    external: false,
  },
] as const;
